export default "__VITE_ASSET__BjgRc10$__"